package org.mkui.graphics.pressure

class LinearPressure : Pressure {
    override fun transform(v: Double): Double {
        return v
    }
}